import { heroCards, heroStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative min-h-screen w-full overflow-hidden bg-foreground-950">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20warm%20dimly%20lit%20private%20study%20at%20night%2C%20stacked%20vintage%20books%20and%20a%20single%20brass%20desk%20lamp%20glow%2C%20amber%20and%20deep%20brown%20tones%20with%20cream%20highlights%2C%20heavy%20soft%20shadows%2C%20geometric%20simplified%20shapes%2C%20no%20text%2C%20cinematic%20moody%20atmosphere%20suggesting%20a%20quiet%20intimate%20tutoring%20space&width=1920&height=1080&seq=secret-teach-hero-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/70 to-foreground-950/90" />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/70 via-transparent to-foreground-950/40" />

      <div className="relative z-10 w-full px-4 md:px-8 pt-28 md:pt-32 pb-16 flex flex-col justify-center min-h-screen">
        <div className="max-w-4xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-accent-300/50 bg-accent-500/15 font-label text-xs md:text-sm text-accent-100">
            <i className="ri-shield-star-line" />
            师生家教题材 · 场景与关系全解析
          </span>

          <h1 className="mt-5 font-heading text-3xl md:text-6xl font-bold leading-tight text-background-50">
            秘密教学
            <span className="block mt-2 text-xl md:text-3xl font-semibold text-primary-200">
              家教 · 私教 · 补习 · 辅导 的关系场景全貌
            </span>
          </h1>

          <p className="mt-5 max-w-2xl text-sm md:text-lg leading-relaxed text-background-100/85">
            围绕师生家教题材，深入解析家教、私教、补习、辅导等不同场景下的角色关系与互动细节，
            从空间、身份与节奏三个切面，带你看清一段关系如何被一步步推进。
          </p>

          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <a
              href="#compare"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-foreground-950 font-label font-medium whitespace-nowrap hover:bg-primary-400 transition-colors"
            >
              <i className="ri-layout-grid-line" />
              对比四种关系场景
            </a>
            <a
              href="#chapters"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/35 text-background-50 font-label font-medium whitespace-nowrap hover:bg-background-50/10 transition-colors"
            >
              <i className="ri-book-open-line" />
              查看章节脉络
            </a>
          </div>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {heroCards.map((card, index) => (
            <a
              key={card.key}
              href="#compare"
              className={`group rounded-lg border p-4 md:p-5 backdrop-blur-sm transition-colors ${
                index === 0
                  ? "border-primary-400/60 bg-primary-500/20 hover:bg-primary-500/30"
                  : "border-background-50/20 bg-background-50/10 hover:bg-background-50/20"
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="w-10 h-10 rounded-md flex items-center justify-center bg-background-50/15 text-background-50">
                  <i className={`${card.icon} text-xl`} />
                </span>
                <i className="ri-arrow-right-up-line text-background-50/50 group-hover:text-background-50 transition-colors" />
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-background-50">
                {card.name}
              </h3>
              <p className="mt-1.5 text-xs md:text-sm leading-relaxed text-background-100/75">
                {card.desc}
              </p>
            </a>
          ))}
        </div>

        <div className="mt-8 md:mt-12 grid grid-cols-2 lg:grid-cols-4 gap-6 border-t border-background-50/15 pt-6">
          {heroStats.map((stat) => (
            <div key={stat.label} className="flex flex-col">
              <span className="font-heading text-3xl md:text-4xl font-bold text-primary-200">
                {stat.value}
              </span>
              <span className="mt-1 font-label text-sm text-background-50">{stat.label}</span>
              <span className="mt-0.5 text-xs text-background-100/60">{stat.desc}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}